import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable()

export class AddAcceptInterceptor implements HttpInterceptor {
  constructor() {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.url.indexOf(environment.api_endpoint) === -1) {
      return next.handle(request);
    }

    request = request.clone({
      withCredentials: true,
      setHeaders: {
        Accept: `application/json`,
      }
    });

    return next.handle(request);
  }
}
